import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const tkn = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user'));
    if (tkn && route.data.role === user.role) {
      return true
    }
    this.router.navigateByUrl("/auth/login");
    return false;
  }

}
